import './style.scss'
import ArtworkDetails from './ArtworkDetails';

export default ArtworkDetails;

